import React, { Component } from "react";
import Flexbox from 'flexbox-react';
import ShopListItemQueueGraphic from './shop_list_item_queue_graphic';

const shopListItemQueue = {
    "margin": "auto",
    "width": "100%"
};

const shopListItemQueueCount = {
    "display": "inline-block",
    "margin": "auto",
    "paddingRight": "4%",
    "width": "7%",
    "fontSize": "1.4em",
    "letterSpacing": "-0.2pt",
    "fontFamily": "GraphikRegular"
};

export default class ShopListItemQueue extends Component {
    render() {
        let graphics = [];
        let currShopQueueCount = this.props.shop.queue_length;
        let graphicsCount = Math.min(currShopQueueCount, 16);
        for(let i = 0; i < graphicsCount; i++) {
            graphics.push(<ShopListItemQueueGraphic key={i}/>)
        }
        return (
            <Flexbox width="100%" height="100%">
                <div style={shopListItemQueueCount}>
                    {this.props.shop.queue_length}
                   </div>
               <div style={shopListItemQueue}>
                       {graphics}
               </div>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_queue.jsx